/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * Relay API
 * Energy utility bill analysis API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BulkUpdateFlatCommissionDto,
  BulkUpdateFlatCommissionResultDto,
  CreateSiteListDto,
  ExportJobDto,
  LinkContractDto,
  LinkContractToSiteListResultDto,
  LinkDealDto,
  LinkDealResponseDto,
  PaginatedSiteListSitesResponseDto,
  PaginatedSiteListsResponseDto,
  PrepareLoaDto,
  PrepareLoaResponseDto,
  QueueExportDto,
  SearchSiteListsResultDto,
  SetTenderChecklistTaskDto,
  SiteListDto,
  SiteListsControllerFindAllParams,
  SiteListsControllerFindSitesForSiteListParams,
  SiteListsControllerResyncRyoForSite202,
  SiteListsControllerSearchParams,
  SiteListsControllerSyncRyo202,
  SiteListsControllerSyncRyoForSite202,
  SiteListsControllerUpdateCloseReviewBody,
  UpdateFlatCommissionDto,
  UpdateSiteListDto
} from '.././schemas';

import { customInstance } from '../../client';




/**
 * @summary Create a new site list
 */
export const siteListsControllerCreate = (
    createSiteListDto: CreateSiteListDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SiteListDto>(
      {url: `/site-lists`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSiteListDto, signal
    },
      );
    }
  


export const getSiteListsControllerCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerCreate>>, TError,{data: CreateSiteListDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerCreate>>, TError,{data: CreateSiteListDto}, TContext> => {

const mutationKey = ['siteListsControllerCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof siteListsControllerCreate>>, {data: CreateSiteListDto}> = (props) => {
          const {data} = props ?? {};

          return  siteListsControllerCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SiteListsControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof siteListsControllerCreate>>>
    export type SiteListsControllerCreateMutationBody = CreateSiteListDto
    export type SiteListsControllerCreateMutationError = unknown

    /**
 * @summary Create a new site list
 */
export const useSiteListsControllerCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerCreate>>, TError,{data: CreateSiteListDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof siteListsControllerCreate>>,
        TError,
        {data: CreateSiteListDto},
        TContext
      > => {

      const mutationOptions = getSiteListsControllerCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get all site lists (paginated)
 */
export const siteListsControllerFindAll = (
    params?: SiteListsControllerFindAllParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedSiteListsResponseDto>(
      {url: `/site-lists`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSiteListsControllerFindAllQueryKey = (params?: SiteListsControllerFindAllParams,) => {
    return [
    `/site-lists`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSiteListsControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof siteListsControllerFindAll>>, TError = unknown>(params?: SiteListsControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerFindAll>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSiteListsControllerFindAllQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof siteListsControllerFindAll>>> = ({ signal }) => siteListsControllerFindAll(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerFindAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SiteListsControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof siteListsControllerFindAll>>>
export type SiteListsControllerFindAllQueryError = unknown


export function useSiteListsControllerFindAll<TData = Awaited<ReturnType<typeof siteListsControllerFindAll>>, TError = unknown>(
 params: undefined |  SiteListsControllerFindAllParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerFindAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteListsControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof siteListsControllerFindAll>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteListsControllerFindAll<TData = Awaited<ReturnType<typeof siteListsControllerFindAll>>, TError = unknown>(
 params?: SiteListsControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerFindAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteListsControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof siteListsControllerFindAll>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteListsControllerFindAll<TData = Awaited<ReturnType<typeof siteListsControllerFindAll>>, TError = unknown>(
 params?: SiteListsControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerFindAll>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all site lists (paginated)
 */

export function useSiteListsControllerFindAll<TData = Awaited<ReturnType<typeof siteListsControllerFindAll>>, TError = unknown>(
 params?: SiteListsControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerFindAll>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSiteListsControllerFindAllQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Search site lists
 */
export const siteListsControllerSearch = (
    params?: SiteListsControllerSearchParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SearchSiteListsResultDto>(
      {url: `/site-lists/search`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSiteListsControllerSearchQueryKey = (params?: SiteListsControllerSearchParams,) => {
    return [
    `/site-lists/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSiteListsControllerSearchQueryOptions = <TData = Awaited<ReturnType<typeof siteListsControllerSearch>>, TError = unknown>(params?: SiteListsControllerSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerSearch>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSiteListsControllerSearchQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof siteListsControllerSearch>>> = ({ signal }) => siteListsControllerSearch(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerSearch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SiteListsControllerSearchQueryResult = NonNullable<Awaited<ReturnType<typeof siteListsControllerSearch>>>
export type SiteListsControllerSearchQueryError = unknown


export function useSiteListsControllerSearch<TData = Awaited<ReturnType<typeof siteListsControllerSearch>>, TError = unknown>(
 params: undefined |  SiteListsControllerSearchParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerSearch>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteListsControllerSearch>>,
          TError,
          Awaited<ReturnType<typeof siteListsControllerSearch>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteListsControllerSearch<TData = Awaited<ReturnType<typeof siteListsControllerSearch>>, TError = unknown>(
 params?: SiteListsControllerSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerSearch>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteListsControllerSearch>>,
          TError,
          Awaited<ReturnType<typeof siteListsControllerSearch>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteListsControllerSearch<TData = Awaited<ReturnType<typeof siteListsControllerSearch>>, TError = unknown>(
 params?: SiteListsControllerSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerSearch>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Search site lists
 */

export function useSiteListsControllerSearch<TData = Awaited<ReturnType<typeof siteListsControllerSearch>>, TError = unknown>(
 params?: SiteListsControllerSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerSearch>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSiteListsControllerSearchQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get a site list by ID
 */
export const siteListsControllerFindOne = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SiteListDto>(
      {url: `/site-lists/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getSiteListsControllerFindOneQueryKey = (id?: string,) => {
    return [
    `/site-lists/${id}`
    ] as const;
    }

    
export const getSiteListsControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof siteListsControllerFindOne>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerFindOne>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSiteListsControllerFindOneQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof siteListsControllerFindOne>>> = ({ signal }) => siteListsControllerFindOne(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SiteListsControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof siteListsControllerFindOne>>>
export type SiteListsControllerFindOneQueryError = void


export function useSiteListsControllerFindOne<TData = Awaited<ReturnType<typeof siteListsControllerFindOne>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerFindOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteListsControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof siteListsControllerFindOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteListsControllerFindOne<TData = Awaited<ReturnType<typeof siteListsControllerFindOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerFindOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteListsControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof siteListsControllerFindOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteListsControllerFindOne<TData = Awaited<ReturnType<typeof siteListsControllerFindOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerFindOne>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a site list by ID
 */

export function useSiteListsControllerFindOne<TData = Awaited<ReturnType<typeof siteListsControllerFindOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerFindOne>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSiteListsControllerFindOneQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update a site list
 */
export const siteListsControllerUpdate = (
    id: string,
    updateSiteListDto: UpdateSiteListDto,
 ) => {
      
      
      return customInstance<SiteListDto>(
      {url: `/site-lists/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateSiteListDto
    },
      );
    }
  


export const getSiteListsControllerUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerUpdate>>, TError,{id: string;data: UpdateSiteListDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerUpdate>>, TError,{id: string;data: UpdateSiteListDto}, TContext> => {

const mutationKey = ['siteListsControllerUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof siteListsControllerUpdate>>, {id: string;data: UpdateSiteListDto}> = (props) => {
          const {id,data} = props ?? {};

          return  siteListsControllerUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SiteListsControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof siteListsControllerUpdate>>>
    export type SiteListsControllerUpdateMutationBody = UpdateSiteListDto
    export type SiteListsControllerUpdateMutationError = void

    /**
 * @summary Update a site list
 */
export const useSiteListsControllerUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerUpdate>>, TError,{id: string;data: UpdateSiteListDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof siteListsControllerUpdate>>,
        TError,
        {id: string;data: UpdateSiteListDto},
        TContext
      > => {

      const mutationOptions = getSiteListsControllerUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Delete a site list
 */
export const siteListsControllerRemove = (
    id: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/site-lists/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getSiteListsControllerRemoveMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerRemove>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerRemove>>, TError,{id: string}, TContext> => {

const mutationKey = ['siteListsControllerRemove'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof siteListsControllerRemove>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  siteListsControllerRemove(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SiteListsControllerRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof siteListsControllerRemove>>>
    
    export type SiteListsControllerRemoveMutationError = void

    /**
 * @summary Delete a site list
 */
export const useSiteListsControllerRemove = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerRemove>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof siteListsControllerRemove>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSiteListsControllerRemoveMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Tick or clear one SME tender checklist task
 */
export const siteListsControllerSetTenderChecklistTask = (
    id: string,
    taskKey: string,
    setTenderChecklistTaskDto: SetTenderChecklistTaskDto,
 ) => {
      
      
      return customInstance<SiteListDto>(
      {url: `/site-lists/${id}/tender-checklist/${taskKey}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: setTenderChecklistTaskDto
    },
      );
    }
  


export const getSiteListsControllerSetTenderChecklistTaskMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerSetTenderChecklistTask>>, TError,{id: string;taskKey: string;data: SetTenderChecklistTaskDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerSetTenderChecklistTask>>, TError,{id: string;taskKey: string;data: SetTenderChecklistTaskDto}, TContext> => {

const mutationKey = ['siteListsControllerSetTenderChecklistTask'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof siteListsControllerSetTenderChecklistTask>>, {id: string;taskKey: string;data: SetTenderChecklistTaskDto}> = (props) => {
          const {id,taskKey,data} = props ?? {};

          return  siteListsControllerSetTenderChecklistTask(id,taskKey,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SiteListsControllerSetTenderChecklistTaskMutationResult = NonNullable<Awaited<ReturnType<typeof siteListsControllerSetTenderChecklistTask>>>
    export type SiteListsControllerSetTenderChecklistTaskMutationBody = SetTenderChecklistTaskDto
    export type SiteListsControllerSetTenderChecklistTaskMutationError = void

    /**
 * @summary Tick or clear one SME tender checklist task
 */
export const useSiteListsControllerSetTenderChecklistTask = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerSetTenderChecklistTask>>, TError,{id: string;taskKey: string;data: SetTenderChecklistTaskDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof siteListsControllerSetTenderChecklistTask>>,
        TError,
        {id: string;taskKey: string;data: SetTenderChecklistTaskDto},
        TContext
      > => {

      const mutationOptions = getSiteListsControllerSetTenderChecklistTaskMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get sites in a site list (paginated + searchable)
 */
export const siteListsControllerFindSitesForSiteList = (
    id: string,
    params?: SiteListsControllerFindSitesForSiteListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedSiteListSitesResponseDto>(
      {url: `/site-lists/${id}/sites`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSiteListsControllerFindSitesForSiteListQueryKey = (id?: string,
    params?: SiteListsControllerFindSitesForSiteListParams,) => {
    return [
    `/site-lists/${id}/sites`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSiteListsControllerFindSitesForSiteListQueryOptions = <TData = Awaited<ReturnType<typeof siteListsControllerFindSitesForSiteList>>, TError = void>(id: string,
    params?: SiteListsControllerFindSitesForSiteListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerFindSitesForSiteList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSiteListsControllerFindSitesForSiteListQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof siteListsControllerFindSitesForSiteList>>> = ({ signal }) => siteListsControllerFindSitesForSiteList(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerFindSitesForSiteList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SiteListsControllerFindSitesForSiteListQueryResult = NonNullable<Awaited<ReturnType<typeof siteListsControllerFindSitesForSiteList>>>
export type SiteListsControllerFindSitesForSiteListQueryError = void


export function useSiteListsControllerFindSitesForSiteList<TData = Awaited<ReturnType<typeof siteListsControllerFindSitesForSiteList>>, TError = void>(
 id: string,
    params: undefined |  SiteListsControllerFindSitesForSiteListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerFindSitesForSiteList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteListsControllerFindSitesForSiteList>>,
          TError,
          Awaited<ReturnType<typeof siteListsControllerFindSitesForSiteList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteListsControllerFindSitesForSiteList<TData = Awaited<ReturnType<typeof siteListsControllerFindSitesForSiteList>>, TError = void>(
 id: string,
    params?: SiteListsControllerFindSitesForSiteListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerFindSitesForSiteList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteListsControllerFindSitesForSiteList>>,
          TError,
          Awaited<ReturnType<typeof siteListsControllerFindSitesForSiteList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteListsControllerFindSitesForSiteList<TData = Awaited<ReturnType<typeof siteListsControllerFindSitesForSiteList>>, TError = void>(
 id: string,
    params?: SiteListsControllerFindSitesForSiteListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerFindSitesForSiteList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get sites in a site list (paginated + searchable)
 */

export function useSiteListsControllerFindSitesForSiteList<TData = Awaited<ReturnType<typeof siteListsControllerFindSitesForSiteList>>, TError = void>(
 id: string,
    params?: SiteListsControllerFindSitesForSiteListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerFindSitesForSiteList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSiteListsControllerFindSitesForSiteListQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Add a site to a site list
 */
export const siteListsControllerAddSiteToSiteList = (
    id: string,
    siteId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/site-lists/${id}/sites/${siteId}`, method: 'POST', signal
    },
      );
    }
  


export const getSiteListsControllerAddSiteToSiteListMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerAddSiteToSiteList>>, TError,{id: string;siteId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerAddSiteToSiteList>>, TError,{id: string;siteId: string}, TContext> => {

const mutationKey = ['siteListsControllerAddSiteToSiteList'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof siteListsControllerAddSiteToSiteList>>, {id: string;siteId: string}> = (props) => {
          const {id,siteId} = props ?? {};

          return  siteListsControllerAddSiteToSiteList(id,siteId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SiteListsControllerAddSiteToSiteListMutationResult = NonNullable<Awaited<ReturnType<typeof siteListsControllerAddSiteToSiteList>>>
    
    export type SiteListsControllerAddSiteToSiteListMutationError = void

    /**
 * @summary Add a site to a site list
 */
export const useSiteListsControllerAddSiteToSiteList = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerAddSiteToSiteList>>, TError,{id: string;siteId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof siteListsControllerAddSiteToSiteList>>,
        TError,
        {id: string;siteId: string},
        TContext
      > => {

      const mutationOptions = getSiteListsControllerAddSiteToSiteListMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Remove a site from a site list
 */
export const siteListsControllerRemoveSiteFromSiteList = (
    id: string,
    siteId: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/site-lists/${id}/sites/${siteId}`, method: 'DELETE'
    },
      );
    }
  


export const getSiteListsControllerRemoveSiteFromSiteListMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerRemoveSiteFromSiteList>>, TError,{id: string;siteId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerRemoveSiteFromSiteList>>, TError,{id: string;siteId: string}, TContext> => {

const mutationKey = ['siteListsControllerRemoveSiteFromSiteList'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof siteListsControllerRemoveSiteFromSiteList>>, {id: string;siteId: string}> = (props) => {
          const {id,siteId} = props ?? {};

          return  siteListsControllerRemoveSiteFromSiteList(id,siteId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SiteListsControllerRemoveSiteFromSiteListMutationResult = NonNullable<Awaited<ReturnType<typeof siteListsControllerRemoveSiteFromSiteList>>>
    
    export type SiteListsControllerRemoveSiteFromSiteListMutationError = void

    /**
 * @summary Remove a site from a site list
 */
export const useSiteListsControllerRemoveSiteFromSiteList = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerRemoveSiteFromSiteList>>, TError,{id: string;siteId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof siteListsControllerRemoveSiteFromSiteList>>,
        TError,
        {id: string;siteId: string},
        TContext
      > => {

      const mutationOptions = getSiteListsControllerRemoveSiteFromSiteListMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update close review data for a site in a site list
 */
export const siteListsControllerUpdateCloseReview = (
    id: string,
    siteId: string,
    siteListsControllerUpdateCloseReviewBody: SiteListsControllerUpdateCloseReviewBody,
 ) => {
      
      
      return customInstance<void>(
      {url: `/site-lists/${id}/sites/${siteId}/close-review`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: siteListsControllerUpdateCloseReviewBody
    },
      );
    }
  


export const getSiteListsControllerUpdateCloseReviewMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerUpdateCloseReview>>, TError,{id: string;siteId: string;data: SiteListsControllerUpdateCloseReviewBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerUpdateCloseReview>>, TError,{id: string;siteId: string;data: SiteListsControllerUpdateCloseReviewBody}, TContext> => {

const mutationKey = ['siteListsControllerUpdateCloseReview'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof siteListsControllerUpdateCloseReview>>, {id: string;siteId: string;data: SiteListsControllerUpdateCloseReviewBody}> = (props) => {
          const {id,siteId,data} = props ?? {};

          return  siteListsControllerUpdateCloseReview(id,siteId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SiteListsControllerUpdateCloseReviewMutationResult = NonNullable<Awaited<ReturnType<typeof siteListsControllerUpdateCloseReview>>>
    export type SiteListsControllerUpdateCloseReviewMutationBody = SiteListsControllerUpdateCloseReviewBody
    export type SiteListsControllerUpdateCloseReviewMutationError = void

    /**
 * @summary Update close review data for a site in a site list
 */
export const useSiteListsControllerUpdateCloseReview = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerUpdateCloseReview>>, TError,{id: string;siteId: string;data: SiteListsControllerUpdateCloseReviewBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof siteListsControllerUpdateCloseReview>>,
        TError,
        {id: string;siteId: string;data: SiteListsControllerUpdateCloseReviewBody},
        TContext
      > => {

      const mutationOptions = getSiteListsControllerUpdateCloseReviewMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Set the SME flat commission for one site in a site list
 */
export const siteListsControllerUpdateFlatCommission = (
    id: string,
    siteId: string,
    updateFlatCommissionDto: UpdateFlatCommissionDto,
 ) => {
      
      
      return customInstance<void>(
      {url: `/site-lists/${id}/sites/${siteId}/flat-commission`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateFlatCommissionDto
    },
      );
    }
  


export const getSiteListsControllerUpdateFlatCommissionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerUpdateFlatCommission>>, TError,{id: string;siteId: string;data: UpdateFlatCommissionDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerUpdateFlatCommission>>, TError,{id: string;siteId: string;data: UpdateFlatCommissionDto}, TContext> => {

const mutationKey = ['siteListsControllerUpdateFlatCommission'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof siteListsControllerUpdateFlatCommission>>, {id: string;siteId: string;data: UpdateFlatCommissionDto}> = (props) => {
          const {id,siteId,data} = props ?? {};

          return  siteListsControllerUpdateFlatCommission(id,siteId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SiteListsControllerUpdateFlatCommissionMutationResult = NonNullable<Awaited<ReturnType<typeof siteListsControllerUpdateFlatCommission>>>
    export type SiteListsControllerUpdateFlatCommissionMutationBody = UpdateFlatCommissionDto
    export type SiteListsControllerUpdateFlatCommissionMutationError = void

    /**
 * @summary Set the SME flat commission for one site in a site list
 */
export const useSiteListsControllerUpdateFlatCommission = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerUpdateFlatCommission>>, TError,{id: string;siteId: string;data: UpdateFlatCommissionDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof siteListsControllerUpdateFlatCommission>>,
        TError,
        {id: string;siteId: string;data: UpdateFlatCommissionDto},
        TContext
      > => {

      const mutationOptions = getSiteListsControllerUpdateFlatCommissionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Set the same SME flat commission across several sites in a site list
 */
export const siteListsControllerBulkUpdateFlatCommission = (
    id: string,
    bulkUpdateFlatCommissionDto: BulkUpdateFlatCommissionDto,
 ) => {
      
      
      return customInstance<BulkUpdateFlatCommissionResultDto>(
      {url: `/site-lists/${id}/sites/flat-commission`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: bulkUpdateFlatCommissionDto
    },
      );
    }
  


export const getSiteListsControllerBulkUpdateFlatCommissionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerBulkUpdateFlatCommission>>, TError,{id: string;data: BulkUpdateFlatCommissionDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerBulkUpdateFlatCommission>>, TError,{id: string;data: BulkUpdateFlatCommissionDto}, TContext> => {

const mutationKey = ['siteListsControllerBulkUpdateFlatCommission'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof siteListsControllerBulkUpdateFlatCommission>>, {id: string;data: BulkUpdateFlatCommissionDto}> = (props) => {
          const {id,data} = props ?? {};

          return  siteListsControllerBulkUpdateFlatCommission(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SiteListsControllerBulkUpdateFlatCommissionMutationResult = NonNullable<Awaited<ReturnType<typeof siteListsControllerBulkUpdateFlatCommission>>>
    export type SiteListsControllerBulkUpdateFlatCommissionMutationBody = BulkUpdateFlatCommissionDto
    export type SiteListsControllerBulkUpdateFlatCommissionMutationError = void

    /**
 * @summary Set the same SME flat commission across several sites in a site list
 */
export const useSiteListsControllerBulkUpdateFlatCommission = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerBulkUpdateFlatCommission>>, TError,{id: string;data: BulkUpdateFlatCommissionDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof siteListsControllerBulkUpdateFlatCommission>>,
        TError,
        {id: string;data: BulkUpdateFlatCommissionDto},
        TContext
      > => {

      const mutationOptions = getSiteListsControllerBulkUpdateFlatCommissionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Retry the RYO calc sync for a link that previously errored
 */
export const siteListsControllerRetryRyoSync = (
    id: string,
    siteId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/site-lists/${id}/sites/${siteId}/retry-ryo-sync`, method: 'POST', signal
    },
      );
    }
  


export const getSiteListsControllerRetryRyoSyncMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerRetryRyoSync>>, TError,{id: string;siteId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerRetryRyoSync>>, TError,{id: string;siteId: string}, TContext> => {

const mutationKey = ['siteListsControllerRetryRyoSync'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof siteListsControllerRetryRyoSync>>, {id: string;siteId: string}> = (props) => {
          const {id,siteId} = props ?? {};

          return  siteListsControllerRetryRyoSync(id,siteId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SiteListsControllerRetryRyoSyncMutationResult = NonNullable<Awaited<ReturnType<typeof siteListsControllerRetryRyoSync>>>
    
    export type SiteListsControllerRetryRyoSyncMutationError = void

    /**
 * @summary Retry the RYO calc sync for a link that previously errored
 */
export const useSiteListsControllerRetryRyoSync = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerRetryRyoSync>>, TError,{id: string;siteId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof siteListsControllerRetryRyoSync>>,
        TError,
        {id: string;siteId: string},
        TContext
      > => {

      const mutationOptions = getSiteListsControllerRetryRyoSyncMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Manually trigger RYO sync for all eligible sites in a site list
 */
export const siteListsControllerSyncRyo = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SiteListsControllerSyncRyo202>(
      {url: `/site-lists/${id}/sync-ryo`, method: 'POST', signal
    },
      );
    }
  


export const getSiteListsControllerSyncRyoMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerSyncRyo>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerSyncRyo>>, TError,{id: string}, TContext> => {

const mutationKey = ['siteListsControllerSyncRyo'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof siteListsControllerSyncRyo>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  siteListsControllerSyncRyo(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SiteListsControllerSyncRyoMutationResult = NonNullable<Awaited<ReturnType<typeof siteListsControllerSyncRyo>>>
    
    export type SiteListsControllerSyncRyoMutationError = void

    /**
 * @summary Manually trigger RYO sync for all eligible sites in a site list
 */
export const useSiteListsControllerSyncRyo = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerSyncRyo>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof siteListsControllerSyncRyo>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSiteListsControllerSyncRyoMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Manually trigger RYO sync for a single site in a site list
 */
export const siteListsControllerSyncRyoForSite = (
    id: string,
    siteId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SiteListsControllerSyncRyoForSite202>(
      {url: `/site-lists/${id}/sites/${siteId}/sync-ryo`, method: 'POST', signal
    },
      );
    }
  


export const getSiteListsControllerSyncRyoForSiteMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerSyncRyoForSite>>, TError,{id: string;siteId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerSyncRyoForSite>>, TError,{id: string;siteId: string}, TContext> => {

const mutationKey = ['siteListsControllerSyncRyoForSite'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof siteListsControllerSyncRyoForSite>>, {id: string;siteId: string}> = (props) => {
          const {id,siteId} = props ?? {};

          return  siteListsControllerSyncRyoForSite(id,siteId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SiteListsControllerSyncRyoForSiteMutationResult = NonNullable<Awaited<ReturnType<typeof siteListsControllerSyncRyoForSite>>>
    
    export type SiteListsControllerSyncRyoForSiteMutationError = void

    /**
 * @summary Manually trigger RYO sync for a single site in a site list
 */
export const useSiteListsControllerSyncRyoForSite = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerSyncRyoForSite>>, TError,{id: string;siteId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof siteListsControllerSyncRyoForSite>>,
        TError,
        {id: string;siteId: string},
        TContext
      > => {

      const mutationOptions = getSiteListsControllerSyncRyoForSiteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Overwrites the calc's customer details in RYO with the site's current values — the way a contact or address linked after the calc was created reaches RYO. Usage, dates and pricing are not re-pushed, so live quotes are unaffected.
 * @summary Re-push a site to its existing RYO calc
 */
export const siteListsControllerResyncRyoForSite = (
    id: string,
    siteId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SiteListsControllerResyncRyoForSite202>(
      {url: `/site-lists/${id}/sites/${siteId}/resync-ryo`, method: 'POST', signal
    },
      );
    }
  


export const getSiteListsControllerResyncRyoForSiteMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerResyncRyoForSite>>, TError,{id: string;siteId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerResyncRyoForSite>>, TError,{id: string;siteId: string}, TContext> => {

const mutationKey = ['siteListsControllerResyncRyoForSite'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof siteListsControllerResyncRyoForSite>>, {id: string;siteId: string}> = (props) => {
          const {id,siteId} = props ?? {};

          return  siteListsControllerResyncRyoForSite(id,siteId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SiteListsControllerResyncRyoForSiteMutationResult = NonNullable<Awaited<ReturnType<typeof siteListsControllerResyncRyoForSite>>>
    
    export type SiteListsControllerResyncRyoForSiteMutationError = void

    /**
 * @summary Re-push a site to its existing RYO calc
 */
export const useSiteListsControllerResyncRyoForSite = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerResyncRyoForSite>>, TError,{id: string;siteId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof siteListsControllerResyncRyoForSite>>,
        TError,
        {id: string;siteId: string},
        TContext
      > => {

      const mutationOptions = getSiteListsControllerResyncRyoForSiteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get export jobs for a site list
 */
export const siteListsControllerGetExportJobs = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ExportJobDto[]>(
      {url: `/site-lists/${id}/export-jobs`, method: 'GET', signal
    },
      );
    }
  



export const getSiteListsControllerGetExportJobsQueryKey = (id?: string,) => {
    return [
    `/site-lists/${id}/export-jobs`
    ] as const;
    }

    
export const getSiteListsControllerGetExportJobsQueryOptions = <TData = Awaited<ReturnType<typeof siteListsControllerGetExportJobs>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerGetExportJobs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSiteListsControllerGetExportJobsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof siteListsControllerGetExportJobs>>> = ({ signal }) => siteListsControllerGetExportJobs(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerGetExportJobs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SiteListsControllerGetExportJobsQueryResult = NonNullable<Awaited<ReturnType<typeof siteListsControllerGetExportJobs>>>
export type SiteListsControllerGetExportJobsQueryError = void


export function useSiteListsControllerGetExportJobs<TData = Awaited<ReturnType<typeof siteListsControllerGetExportJobs>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerGetExportJobs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteListsControllerGetExportJobs>>,
          TError,
          Awaited<ReturnType<typeof siteListsControllerGetExportJobs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteListsControllerGetExportJobs<TData = Awaited<ReturnType<typeof siteListsControllerGetExportJobs>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerGetExportJobs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteListsControllerGetExportJobs>>,
          TError,
          Awaited<ReturnType<typeof siteListsControllerGetExportJobs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteListsControllerGetExportJobs<TData = Awaited<ReturnType<typeof siteListsControllerGetExportJobs>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerGetExportJobs>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get export jobs for a site list
 */

export function useSiteListsControllerGetExportJobs<TData = Awaited<ReturnType<typeof siteListsControllerGetExportJobs>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerGetExportJobs>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSiteListsControllerGetExportJobsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create an export job for a site list
 */
export const siteListsControllerCreateExportJob = (
    id: string,
    queueExportDto: QueueExportDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ExportJobDto>(
      {url: `/site-lists/${id}/export-jobs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: queueExportDto, signal
    },
      );
    }
  


export const getSiteListsControllerCreateExportJobMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerCreateExportJob>>, TError,{id: string;data: QueueExportDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerCreateExportJob>>, TError,{id: string;data: QueueExportDto}, TContext> => {

const mutationKey = ['siteListsControllerCreateExportJob'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof siteListsControllerCreateExportJob>>, {id: string;data: QueueExportDto}> = (props) => {
          const {id,data} = props ?? {};

          return  siteListsControllerCreateExportJob(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SiteListsControllerCreateExportJobMutationResult = NonNullable<Awaited<ReturnType<typeof siteListsControllerCreateExportJob>>>
    export type SiteListsControllerCreateExportJobMutationBody = QueueExportDto
    export type SiteListsControllerCreateExportJobMutationError = void

    /**
 * @summary Create an export job for a site list
 */
export const useSiteListsControllerCreateExportJob = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerCreateExportJob>>, TError,{id: string;data: QueueExportDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof siteListsControllerCreateExportJob>>,
        TError,
        {id: string;data: QueueExportDto},
        TContext
      > => {

      const mutationOptions = getSiteListsControllerCreateExportJobMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Link an Attio deal to a site list
 */
export const siteListsControllerLinkDeal = (
    id: string,
    linkDealDto: LinkDealDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<LinkDealResponseDto>(
      {url: `/site-lists/${id}/deal`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: linkDealDto, signal
    },
      );
    }
  


export const getSiteListsControllerLinkDealMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerLinkDeal>>, TError,{id: string;data: LinkDealDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerLinkDeal>>, TError,{id: string;data: LinkDealDto}, TContext> => {

const mutationKey = ['siteListsControllerLinkDeal'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof siteListsControllerLinkDeal>>, {id: string;data: LinkDealDto}> = (props) => {
          const {id,data} = props ?? {};

          return  siteListsControllerLinkDeal(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SiteListsControllerLinkDealMutationResult = NonNullable<Awaited<ReturnType<typeof siteListsControllerLinkDeal>>>
    export type SiteListsControllerLinkDealMutationBody = LinkDealDto
    export type SiteListsControllerLinkDealMutationError = void

    /**
 * @summary Link an Attio deal to a site list
 */
export const useSiteListsControllerLinkDeal = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerLinkDeal>>, TError,{id: string;data: LinkDealDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof siteListsControllerLinkDeal>>,
        TError,
        {id: string;data: LinkDealDto},
        TContext
      > => {

      const mutationOptions = getSiteListsControllerLinkDealMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Unlink Attio deal from a site list
 */
export const siteListsControllerUnlinkDeal = (
    id: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/site-lists/${id}/deal`, method: 'DELETE'
    },
      );
    }
  


export const getSiteListsControllerUnlinkDealMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerUnlinkDeal>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerUnlinkDeal>>, TError,{id: string}, TContext> => {

const mutationKey = ['siteListsControllerUnlinkDeal'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof siteListsControllerUnlinkDeal>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  siteListsControllerUnlinkDeal(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SiteListsControllerUnlinkDealMutationResult = NonNullable<Awaited<ReturnType<typeof siteListsControllerUnlinkDeal>>>
    
    export type SiteListsControllerUnlinkDealMutationError = void

    /**
 * @summary Unlink Attio deal from a site list
 */
export const useSiteListsControllerUnlinkDeal = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerUnlinkDeal>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof siteListsControllerUnlinkDeal>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSiteListsControllerUnlinkDealMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Preview linking a site list to a contract
 */
export const siteListsControllerPreviewLinkContract = (
    id: string,
    contractId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<LinkContractToSiteListResultDto>(
      {url: `/site-lists/${id}/contract/${contractId}/preview`, method: 'GET', signal
    },
      );
    }
  



export const getSiteListsControllerPreviewLinkContractQueryKey = (id?: string,
    contractId?: string,) => {
    return [
    `/site-lists/${id}/contract/${contractId}/preview`
    ] as const;
    }

    
export const getSiteListsControllerPreviewLinkContractQueryOptions = <TData = Awaited<ReturnType<typeof siteListsControllerPreviewLinkContract>>, TError = void>(id: string,
    contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerPreviewLinkContract>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSiteListsControllerPreviewLinkContractQueryKey(id,contractId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof siteListsControllerPreviewLinkContract>>> = ({ signal }) => siteListsControllerPreviewLinkContract(id,contractId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id && contractId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerPreviewLinkContract>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SiteListsControllerPreviewLinkContractQueryResult = NonNullable<Awaited<ReturnType<typeof siteListsControllerPreviewLinkContract>>>
export type SiteListsControllerPreviewLinkContractQueryError = void


export function useSiteListsControllerPreviewLinkContract<TData = Awaited<ReturnType<typeof siteListsControllerPreviewLinkContract>>, TError = void>(
 id: string,
    contractId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerPreviewLinkContract>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteListsControllerPreviewLinkContract>>,
          TError,
          Awaited<ReturnType<typeof siteListsControllerPreviewLinkContract>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteListsControllerPreviewLinkContract<TData = Awaited<ReturnType<typeof siteListsControllerPreviewLinkContract>>, TError = void>(
 id: string,
    contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerPreviewLinkContract>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteListsControllerPreviewLinkContract>>,
          TError,
          Awaited<ReturnType<typeof siteListsControllerPreviewLinkContract>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteListsControllerPreviewLinkContract<TData = Awaited<ReturnType<typeof siteListsControllerPreviewLinkContract>>, TError = void>(
 id: string,
    contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerPreviewLinkContract>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Preview linking a site list to a contract
 */

export function useSiteListsControllerPreviewLinkContract<TData = Awaited<ReturnType<typeof siteListsControllerPreviewLinkContract>>, TError = void>(
 id: string,
    contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteListsControllerPreviewLinkContract>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSiteListsControllerPreviewLinkContractQueryOptions(id,contractId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Link a contract to a site list
 */
export const siteListsControllerLinkContract = (
    id: string,
    linkContractDto: LinkContractDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<LinkContractToSiteListResultDto>(
      {url: `/site-lists/${id}/contract`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: linkContractDto, signal
    },
      );
    }
  


export const getSiteListsControllerLinkContractMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerLinkContract>>, TError,{id: string;data: LinkContractDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerLinkContract>>, TError,{id: string;data: LinkContractDto}, TContext> => {

const mutationKey = ['siteListsControllerLinkContract'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof siteListsControllerLinkContract>>, {id: string;data: LinkContractDto}> = (props) => {
          const {id,data} = props ?? {};

          return  siteListsControllerLinkContract(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SiteListsControllerLinkContractMutationResult = NonNullable<Awaited<ReturnType<typeof siteListsControllerLinkContract>>>
    export type SiteListsControllerLinkContractMutationBody = LinkContractDto
    export type SiteListsControllerLinkContractMutationError = void

    /**
 * @summary Link a contract to a site list
 */
export const useSiteListsControllerLinkContract = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerLinkContract>>, TError,{id: string;data: LinkContractDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof siteListsControllerLinkContract>>,
        TError,
        {id: string;data: LinkContractDto},
        TContext
      > => {

      const mutationOptions = getSiteListsControllerLinkContractMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Prepare a DocuSeal Letter of Authority for a site list
 */
export const siteListsControllerPrepareLoa = (
    id: string,
    prepareLoaDto: PrepareLoaDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PrepareLoaResponseDto>(
      {url: `/site-lists/${id}/prepare-loa`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: prepareLoaDto, signal
    },
      );
    }
  


export const getSiteListsControllerPrepareLoaMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerPrepareLoa>>, TError,{id: string;data: PrepareLoaDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerPrepareLoa>>, TError,{id: string;data: PrepareLoaDto}, TContext> => {

const mutationKey = ['siteListsControllerPrepareLoa'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof siteListsControllerPrepareLoa>>, {id: string;data: PrepareLoaDto}> = (props) => {
          const {id,data} = props ?? {};

          return  siteListsControllerPrepareLoa(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SiteListsControllerPrepareLoaMutationResult = NonNullable<Awaited<ReturnType<typeof siteListsControllerPrepareLoa>>>
    export type SiteListsControllerPrepareLoaMutationBody = PrepareLoaDto
    export type SiteListsControllerPrepareLoaMutationError = void

    /**
 * @summary Prepare a DocuSeal Letter of Authority for a site list
 */
export const useSiteListsControllerPrepareLoa = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof siteListsControllerPrepareLoa>>, TError,{id: string;data: PrepareLoaDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof siteListsControllerPrepareLoa>>,
        TError,
        {id: string;data: PrepareLoaDto},
        TContext
      > => {

      const mutationOptions = getSiteListsControllerPrepareLoaMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    